/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RunEventRequestDto } from '../models/run-event-request-dto';
import { RunServiceRequestDto } from '../models/run-service-request-dto';
import { RunStepFunctionRequestDto } from '../models/run-step-function-request-dto';

@Injectable({
  providedIn: 'root',
})
export class WorkflowManagementControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation workflowManagementControllerRunEvent
   */
  static readonly WorkflowManagementControllerRunEventPath = '/workflow-management/workflow-events/run';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runEvent$Response(params?: {
    body?: RunEventRequestDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunEventPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runEvent(params?: {
    body?: RunEventRequestDto
  }): Observable<void> {

    return this.runEvent$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunServiceSync
   */
  static readonly WorkflowManagementControllerRunServiceSyncPath = '/workflow-management/workflow-step-function-services/run-sync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runServiceSync()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runServiceSync$Response(params?: {
    body?: RunServiceRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunServiceSyncPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runServiceSync$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runServiceSync(params?: {
    body?: RunServiceRequestDto
  }): Observable<any> {

    return this.runServiceSync$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunStepFunctionAsync
   */
  static readonly WorkflowManagementControllerRunStepFunctionAsyncPath = '/workflow-management/workflow-step-functions/run-async';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runStepFunctionAsync()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runStepFunctionAsync$Response(params?: {
    body?: RunStepFunctionRequestDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunStepFunctionAsyncPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runStepFunctionAsync$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runStepFunctionAsync(params?: {
    body?: RunStepFunctionRequestDto
  }): Observable<void> {

    return this.runStepFunctionAsync$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation workflowManagementControllerRunStepFunctionSync
   */
  static readonly WorkflowManagementControllerRunStepFunctionSyncPath = '/workflow-management/workflow-step-functions/run-sync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `runStepFunctionSync()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runStepFunctionSync$Response(params?: {
    body?: RunStepFunctionRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowManagementControllerService.WorkflowManagementControllerRunStepFunctionSyncPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `runStepFunctionSync$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  runStepFunctionSync(params?: {
    body?: RunStepFunctionRequestDto
  }): Observable<any> {

    return this.runStepFunctionSync$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

}
